import { render, staticRenderFns } from "./provinceFixPriceAddDialog.vue?vue&type=template&id=08e69be1"
import script from "./provinceFixPriceAddDialog.vue?vue&type=script&lang=js"
export * from "./provinceFixPriceAddDialog.vue?vue&type=script&lang=js"
import style0 from "./provinceFixPriceAddDialog.vue?vue&type=style&index=0&id=08e69be1&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08e69be1')) {
      api.createRecord('08e69be1', component.options)
    } else {
      api.reload('08e69be1', component.options)
    }
    module.hot.accept("./provinceFixPriceAddDialog.vue?vue&type=template&id=08e69be1", function () {
      api.rerender('08e69be1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shopOperationCenter/dialog/provinceFixPriceAddDialog.vue"
export default component.exports